/* eslint-disable no-empty-pattern */
import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useState} from 'react';
import {Card} from '../../components/Card';
import {mainState} from '../../AppMainState';
import {Button} from '../../components/Button';
import {PaymentsViewState} from './PaymentsViewState';
import {ChooseOffer} from './ChooseOffer';
import {formatDate} from '../../helpers/helpers';
import {MusculaSubscritpionPlan} from '../../swagger';

export const PaymentsView: FC = observer(() => {
    if (!mainState.currentUser) {
        return <div />;
    }

    const [state] = useState(() => new PaymentsViewState());

    return <div className="h-full">
        {/*        <section className="mb-6" id="order">
            <h1 className="font-bold font-roboto-bold mb-4 text-3xl">Billing</h1>
        </section>*/}
        <section className="mb-6" id="payments-history">
            <h1 className="font-bold font-roboto-bold mb-4 text-3xl">Current subscription</h1>
            <div>You can only see here own subscriptions for your projects. Subscriptions for projects where you are a guest are not shown here.
            </div>
            <Card className="mb-4">
                <div className="flex flex-wrap items-center justify-between">
                    <div className="flex flex-col font-bold md:block">
                        {mainState.currentUser.musculaSubscritpionPlan !== MusculaSubscritpionPlan.MusculaBasic &&
                        <span className="mr-4">Expires: {formatDate(mainState.currentUser.accountExpires!)}</span>}
                        <span
                            className="text-m-green">
                            Current plan: {mainState.currentUser.trial ? 'Trial' : mainState.currentUser.musculaSubscritpionPlan}</span>
                        {mainState.currentUser.receiptUrl &&
                        <span><a href={mainState.currentUser.receiptUrl} className="ml-4" rel="noopener noreferrer" target="_blank">Receipt</a></span>}
                    </div>
                    <div className="flex flex-col md:block">
                        {!mainState.isActiveSubscription &&
                        <span className="font-medium text-lg text-right text-m-brand-red">Expired</span>}
                        {!mainState.currentUser.trial && mainState.isActiveSubscription && mainState.currentUser.subscriptionUpdateUrl &&
                        <a href={mainState.currentUser.subscriptionUpdateUrl} className="btn btn-light ml-4 mt-3 md:mt-0" rel="noopener noreferrer"
                           target="_blank">Update
                            subscription</a>}
                        {(mainState.currentUser.trial || !mainState.isActiveSubscription) &&
                        <Button className="btn-primary ml-4 mt-3 md:mt-0"
                                onClick={() => state.subscribe()}>
                            Subscribe
                        </Button>}
                    </div>
                </div>

            </Card>
        </section>
        {(mainState.currentUser.trial || mainState.currentUser.musculaSubscritpionPlan === MusculaSubscritpionPlan.MusculaBasic) && <ChooseOffer/>}
    </div>
        ;
});
